// extracted by extract-css-chunks-webpack-plugin
module.exports = {"overlayOnHover":"_2cdm2R","authorAvatarImage":"_2axnb_","authorAvatarPreload":"_2uyug_"};